export default __webpack_public_path__ + "static/media/marker.d4f8376d.svg";